import { db } from 'firebase/index'
import React, { FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styles from 'styles/components/template.module.scss'
import { useString, useCheckbox } from 'hooks/form'
import { MainHeadline, Description, SubDescription } from 'components/Typography'
import { NavButton, BlueButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { FormLabel } from 'components/Label'
import { TextInput, Checkbox } from 'components/Form'
import { fetchBrand } from 'repos/brand'
import { fetchStores } from 'repos/store'
import { confirmBrand } from 'reducks/brand/operations'
import { StoreType } from 'types/store'

type Props = {
  isEdit: boolean
  brandId?: string
}

const BrandEditTemplate: FC<Props> = (props) => {
  const { isEdit, brandId } = props
  const dispatch = useDispatch()

  const [stores, setStores] = useState<StoreType[]>([])
  const { state: brandName, handleState: handleBrandName, setState: setBrandName } = useString<string>('')
  const [brandStores, setBrandStores] = useState<string[]>([])
  const handleBrandStores = useCheckbox(setBrandStores)

  const updateBrandStores = async () => {
    await dispatch(
      confirmBrand({
        brand_ref: brandId ? db.collection('brands').doc(brandId) : db.collection('brands').doc(),
        name: brandName,
        store_refs: brandStores.map((brandStore) => db.collection('stores').doc(brandStore)),
      })
    )
    isEdit && brandId
      ? dispatch(push(`/admin/brand/${brandId}/manager`))
      : dispatch(push(`/admin/brand/create/manager`))
  }

  useEffect(() => {
    ;(async () => {
      const _stores = await fetchStores(['public'])
      setStores([..._stores])
    })()
  }, [])

  // 編集画面の場合、既存の値を設定する
  useEffect(() => {
    ;(async () => {
      if (!isEdit || !brandId) return
      const brand = await fetchBrand(brandId)
      if (!brand) return
      setBrandName(brand.name)
      setBrandStores(brand.store_refs.map((store) => store.id))
    })()
  }, [isEdit, brandId])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={isEdit ? 'ブランドを編集する' : 'ブランドを登録する'} />
      <Spacer size={28} />
      <Description description={'必要な情報を登録してください'} />
      <Spacer size={48} />
      <FormLabel label={'ブランド名'} required={true} />
      <Spacer size={12} />
      <TextInput
        disabled={false}
        required={false}
        onChange={handleBrandName}
        placeholder={'sacri Group'}
        type={'text'}
        value={brandName}
      />
      <Spacer size={16} />
      <FormLabel label={'ブランドに紐付く店舗を選択する'} required={false} />
      <Spacer size={8} />
      <SubDescription description={'アクセスを許可する店舗にチェックを入れてください。'} />
      <Spacer size={8} />
      {stores.map((store) => {
        if (!store.store_id) return
        return (
          <div key={store.store_id}>
            <Checkbox
              id={store.store_id}
              isChecked={brandStores.includes(store.store_id)}
              onChange={handleBrandStores}
              label={store.name}
            />
          </div>
        )
      })}
      <Spacer size={48} />
      <BlueButton
        disabled={brandName === ''}
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'次へ進む'}
        onClick={updateBrandStores}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={48} />
    </div>
  )
}

export default BrandEditTemplate
